module.exports = __webpack_public_path__ + "img/none-content.af7e372a.png";